<template>
  <div class="flex w-64 flex-col gap-2 p-3">
    <UiInputSelectVee
      name="roleFilter"
      :label="$t('term.role')"
      :options="roleOptions"
      v-model="roleFilter" />

    <div class="flex items-center justify-between border-t border-border-subtle pt-3">
      <button
        type="button"
        class="cursor-pointer text-sm text-action disabled:cursor-not-allowed disabled:opacity-40"
        :disabled="!roleFilter"
        @click="roleFilter = ''">
        {{ $t('W: Ryd filtre') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { useCustomerUserStore } from '@/stores/customerUserStore'
import { getRoleDisplayName } from '@/globals/typescript/utils/roleUtils'
import { labCustomerUserBusinessRoles } from '@team-milva/lab-models/user'
import { mapWritableState } from 'pinia'

export default {
  name: 'CustomerUserRoleFilterMenu',

  emits: ['close'],

  computed: {
    ...mapWritableState(useCustomerUserStore, ['roleFilter']),

    roleOptions(): { value: string; text: string }[] {
      return [
        { value: '', text: this.$t('W: Alle roller') },
        ...labCustomerUserBusinessRoles.map((role) => ({
          value: role,
          text: getRoleDisplayName(role),
        })),
      ]
    },
  },
}
</script>
